import React, { useState, useEffect, useCallback, useMemo } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Button } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { StepperComponent } from "../../../../../components/common/Stepper/StepperComponent";
import Typography from "@material-ui/core/Typography";
import { TickIcon } from "../../../LeftNav/SvgIcons";
import { CancleIcon } from "../../../LeftNav/SvgIcons";
import { Add } from "@material-ui/icons";
import RecieptModal from "../RequestProduct/RecieptModal";
import { IconButton } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import Autocomplete from "react-google-autocomplete";
import SelectProductModal from "./SelectProductModal";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

import {
  Marine,
  Motorcycles,
  Spa,
  Star,
  Lighting,
  Powersports,
  House,
  Grill,
} from "../../../../../components/common/EnvironmentSvg";
import CustomCheckbox from "../../../../../components/common/checkbox/CustomCheckbox";
import { useDispatch, useSelector } from "react-redux";
import { endUserActions } from "../../../../../store/endUser/endUserActions";
import { toast } from "react-toastify";
import InputField from "../../../../../components/common/InputField";
import BussinesContactChooseLoction from "./BussinesContactChooseLoction";
import { NewProductDetail } from "./NewProductDetail";
import moment from "moment";
import AutoComplete from "../../../../../components/common/AutoComplete";
import { debounce } from "lodash";
import { Img } from "react-image";
import { noImage } from "../../../../../resources/images";
import { useDebounce } from "../../../../../utils/use-debounce";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";

function getSteps() {
  return ["Location", "Environment", "Device Details", "Overview"];
}

function getEndUserSteps() {
  return ["Environment", "Device Details", "Overview"];
}

export const AddNewProduct = ({
  userId,
  setIsNewProduct,
  isBusinessCustomers,
  setCompanyId,
}) => {
  const { deviceOverviewInfo, envWithDeviceCount, envIcons } = useSelector(
    state => state.endUserReducer
  );
  const dispatch = useDispatch();
  const location = useLocation();
  const [environmentAddress, setEnvironmentAddress] = useState("");
  const [envName, setEnvName] = useState("");
  const [envIcon, setEnvIcon] = useState(null);
  const [selectEnv, setSelectEnv] = useState("");
  const [envLat, setEnvLat] = useState("");
  const [envLong, setEnvLong] = useState("");
  const [sameAddress, setSameAddress] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [isUploadRecieptModal, setIsUploadRecieptModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isExpan, setIsExpan] = useState(false);
  const [userAddress, setUserAddress] = useState("");
  const [serialNo, setSerialNo] = useState("");
  const [recipt, setRecipt] = useState({
    name: "",
    receipt: "",
    receiptType: "",
  });

  const [isNewEnvironmentAdd, setIsNewEnvironmentAdd] = useState(false);
  const [allDelears, setAllDelears] = useState([]);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [serLengthError, setSerLengthError] = useState(false);
  const { debouncedValue } = useDebounce(serialNo, 500);

  const maxPurchaseDate = useMemo(() => {
    const currentDate = new Date();
    const formattedCurrentDate = moment(currentDate).format("YYYY-MM-DD");

    const installationDate = new Date(deviceOverviewInfo?.installationDate);
    const formattedInstallationDate =
      moment(installationDate).format("YYYY-MM-DD");
    return deviceOverviewInfo?.installationDate
      ? formattedInstallationDate
      : formattedCurrentDate;
  }, [deviceOverviewInfo?.installationDate]);

  const insallationDateLimits = useMemo(() => {
    const maxDate = moment(new Date()).format("YYYY/MM/DD");

    const purchaseDate = new Date(deviceOverviewInfo?.purchaseDate);
    const formattedPurchaseDate = moment(purchaseDate).format("YYYY/MM/DD");

    return {
      max: maxDate,
      min: formattedPurchaseDate,
    };
  }, [deviceOverviewInfo?.purchaseDate]);

  const onSaveEnv = () => {
    if (
      envName?.trim() !== "" &&
      environmentAddress?.trim() !== "" &&
      envIcon !== "" &&
      envIcon !== null
    ) {
      const envDataSet = {
        environmentId: 0,
        environmentName: envName,
        environmentIcon: envIcon,
        environmentType: "d",
        status: 1,
        userId:
          location.pathname !== "/business-customer"
            ? userId
            : deviceOverviewInfo?.companyUser?.id,
        location: environmentAddress,
        latitude: envLat,
        longitude: envLong,
        isSameAccountLocation: sameAddress,
      };
      setLoading(true);
      dispatch(endUserActions.onAddUpdateEnv(envDataSet)).then(data => {
        if (data && data.success) {
          toast.success("Environment is added successfully");
          dispatch(
            endUserActions.onGetEnvWithDeviceCount(
              location.pathname !== "/business-customer"
                ? userId
                : deviceOverviewInfo?.companyUser?.id
            )
          );
          setEnvName("");
          setEnvIcon("");
          setSameAddress(false);
          setEnvironmentAddress("");
          setEnvLat("");
          setEnvLong("");
        } else {
          setLoading(false);
          if (data) {
            toast.error(data.message);
          }
        }
      });
    } else {
      if (envName?.trim() === "") {
        toast.error("Environment Name cannot be empty");
      } else if (envIcon === "" || envIcon === null) {
        toast.error("Please select environment icon");
      } else {
        toast.error("Environment Address cannot be empty");
      }
    }
  };
  const onSameAddressPress = test => {
    if (test.target.checked) {
      setSameAddress(true);
      setEnvironmentAddress(userAddress);
      setEnvLat("");
      setEnvLong("");
    } else {
      setSameAddress(false);
      setEnvironmentAddress("");
      setEnvLat("");
      setEnvLong("");
    }
  };

  const onExpanButton = () => {
    setIsExpan(!isExpan);
  };
  const hansleaddNewEnviroment = () => {
    setIsNewEnvironmentAdd(true);
  };

  const returnIcons = icon => {
    if (icon === "vector_0" || icon === "vector_00") {
      return <House />;
    } else if (icon === "vector_1" || icon === "vector_01") {
      return <Grill />;
    } else if (icon === "vector_2" || icon === "vector_02") {
      return <Lighting />;
    } else if (icon === "vector_3" || icon === "vector_03") {
      return <Marine />;
    } else if (icon === "vector_4" || icon === "vector_04") {
      return <Spa />;
    } else if (icon === "vector_5" || icon === "vector_05") {
      return <Motorcycles />;
    } else if (icon === "vector_6" || icon === "vector_06") {
      return <Powersports />;
    } else if (icon === "vector_7" || icon === "vector_07") {
      return <Star />;
    }
  };

  useEffect(() => {
    if (userId && !isBusinessCustomers) {
      setLoading(true);
      dispatch(endUserActions.onGetUserById(userId)).then(data => {
        setTimeout(function () {
          setLoading(false);
        }, 3000);
        if (data && data.success) {
          if (data.data) {
            const record = data.data;
            setUserAddress(record.address);
          }
        } else {
          if (data) {
            toast.error(data.message);
          }
        }
      });
      dispatch(endUserActions.onGetEnvIcons());
      dispatch(endUserActions.onGetEnvWithDeviceCount(userId));
    }
  }, []);

  const steps =
    location.pathname === "/business-customer" ? getSteps() : getEndUserSteps();
  const isStepValid = step => {
    if (location?.pathname === "/business-customer" && step === 0) {
      return (
        deviceOverviewInfo?.companyLocation && deviceOverviewInfo?.companyUser
      );
    } else if (
      (location?.pathname === "/business-customer" && step === 1) ||
      (location?.pathname !== "/business-customer" && step === 0)
    ) {
      return selectEnv !== "";
    } else if (
      (location?.pathname === "/business-customer" && step === 2) ||
      (location?.pathname !== "/business-customer" && step === 1)
    ) {
      return (
        deviceOverviewInfo?.deviceName &&
        deviceOverviewInfo?.serialNumber &&
        // deviceOverviewInfo?.installationDate &&
        deviceOverviewInfo?.purchaseDate &&
        (deviceOverviewInfo?.purchaseLocation ||
          deviceOverviewInfo?.companyUser?.contactName) &&
        // deviceOverviewInfo?.purchaseLocId !== "" &&)
        !isDuplicate
      );
    }
    return true;
  };
  const handleNext = () => {
    if (
      location?.pathname === "/business-customer"
        ? activeStep < 3
        : activeStep < 2
    ) {
      setActiveStep(activeStep + 1);
    } else {
      const deviceData = {
        userId:
          location.pathname !== "/business-customer"
            ? userId
            : deviceOverviewInfo?.companyUser?.id,
        installationDate: moment(deviceOverviewInfo?.installationDate).format(
          "MM/DD/YYYY"
        ),
        envId: deviceOverviewInfo?.DeviceEnv?.id,
        dealerLocationId: deviceOverviewInfo?.purchaseLocId,
        companyLocationId: deviceOverviewInfo?.comLocId,
        serialNo: deviceOverviewInfo?.serialNumber,
        purchaseDate: moment(deviceOverviewInfo?.purchaseDate).format(
          "MM/DD/YYYY"
        ),
        receipt: deviceOverviewInfo?.receipt,
        receiptType: deviceOverviewInfo?.receiptType,
        productId: deviceOverviewInfo?.slectedDevice?.id,
        name: deviceOverviewInfo?.deviceName,
        spaBrand: deviceOverviewInfo?.slectedDevice.brand,
      };
      setLoading(true);
      dispatch(endUserActions.onSaveDevice(deviceData)).then(data => {
        if (data && data.success) {
          if (location.pathname !== "/business-customer") {
            dispatch(endUserActions.onGetUserDevices(userId));
          } else {
            dispatch(endUserActions.onGetCompanyDevices(Number(userId))).then(
              data => {
                setLoading(false);
              }
            );
          }
          toast.success("Register Product successfully");
        } else {
          if (data) {
            toast.error("Register Product failed");
          }
        }
      });
      setIsNewProduct(false);
      setLoading(false);
    }
  };

  const handleDeleteFile = () => {
    setRecipt({ receipt: "", receiptType: "", name: "" });
  };

  const recieptModal = item => {
    setOpen(!open);
    if (item) {
      setIsUploadRecieptModal(true);
    } else {
      setIsUploadRecieptModal(false);
    }
  };

  const onSelectProductModal = item => {
    setOpenModal(!openModal);
  };

  const onBackToProducts = () => {
    setIsNewProduct(false);
    dispatch(endUserActions.onResetRegister("deviceOverviewInfo", ""));
  };

  const onSelectEnv = item => {
    setSelectEnv(item);
    dispatch(endUserActions.onChangeOfRegister("DeviceEnv", item));
  };
  const changeHandler = (event, deviceOverviewInfo) => {
    setLoading(true);
    dispatch(
      endUserActions.onGetAllDelears(
        event.target.value,
        deviceOverviewInfo?.slectedDevice?.catergoryId
      )
    ).then(res => {
      setAllDelears(res?.data || []);
      setLoading(false);
    });
  };
  const debouncedChangeHandler = useCallback(debounce(changeHandler, 500), []);

  const onCheckDuplicate = () => {
    dispatch(
      endUserActions.onChangeOfRegister(
        "serialNumber",
        deviceOverviewInfo?.serialNumber
      )
    );
    if (
      deviceOverviewInfo?.serialNumber !== "" &&
      deviceOverviewInfo?.serialNumber?.length > 50
    ) {
      setSerLengthError(true);
    } else {
      setSerLengthError(false);
      setLoading(true);
      if (deviceOverviewInfo?.serialNumber !== "") {
        dispatch(
          endUserActions.onGetDuplicateSr(deviceOverviewInfo?.serialNumber)
        ).then(data => {
          if (data && !data.success) {
            setIsDuplicate(true);
          } else {
            setIsDuplicate(false);
          }
          setLoading(false);
        });
      }
    }
  };
  useEffect(() => {
    if (serialNo !== "") {
      dispatch(endUserActions.onGetDuplicateSr(serialNo)).then(data => {
        if (data && !data.success) {
          setIsDuplicate(true);
        } else {
          setIsDuplicate(false);
        }
        setLoading(false);
      });
    }
  }, [debouncedValue]);
  const maxItemsToShow = 3;
  return (
    <div className='registerProductContainer'>
      <div className='registerNavigations'>
        <div>
          <h1 className='endCustomerHeading'>Register New Product</h1>
          <Button
            color='primary'
            onClick={() => onBackToProducts()}
            startIcon={<ArrowBackIosIcon style={{ fontSize: "15px" }} />}
            className='backbtn'>
            Back to Products Owned
          </Button>
        </div>
        {/* stepper component  */}
        <div className='stepper'>
          <StepperComponent steps={steps} activeStep={activeStep} />
        </div>
      </div>
      <div className='stepperContentContainer'>
        {location?.pathname === "/business-customer" && activeStep === 0 ? (
          isBusinessCustomers ? (
            <BussinesContactChooseLoction companyId={userId} />
          ) : null
        ) : null}
        {(location?.pathname === "/business-customer" && activeStep === 1) ||
        (location?.pathname !== "/business-customer" && activeStep === 0) ? (
          <div className='firstStepperContent'>
            <ValidatorForm>
              <div className='choseEnviroment'>
                <h1 className='chooseContentHeading'>Choose Environment</h1>
                {envWithDeviceCount &&
                  envWithDeviceCount.length > 0 &&
                  envWithDeviceCount
                    .slice(0, isExpan ? undefined : maxItemsToShow)
                    .map((item, index) => (
                      <div>
                        <div
                          key={index}
                          className={`item ${
                            item === selectEnv
                              ? "selectedEnviromentItems"
                              : "enviromentItems"
                          }`}
                          onClick={() => onSelectEnv(item)}>
                          <div>
                            {item?.icon.substring(0, 5) === "https" ? (
                              <Img src={[item?.icon, noImage]} alt='Icon' />
                            ) : (
                              <span className='envIcon'>
                                {returnIcons(item?.icon)}
                              </span>
                            )}
                          </div>
                          <div className='enviromentItemsDetails'>
                            <span>{item?.name}</span>
                            <span>{item?.devicesCount} Devices</span>
                          </div>
                        </div>
                      </div>
                    ))}
                <div className='accordion'>
                  <div onClick={onExpanButton}>
                    <span className={isExpan ? "expan" : "noExpan"}>
                      Show more
                      <ExpandLessIcon />
                    </span>
                  </div>
                </div>
                <div className='newEnvironmentHeaderContainer'>
                  <h1 className='stepperContentHeading'>New Environment</h1>
                  {!isNewEnvironmentAdd && (
                    <Button
                      color='primary'
                      variant='contained'
                      className='dashboardButtons'
                      onClick={hansleaddNewEnviroment}>
                      Add New Environment
                    </Button>
                  )}
                </div>
                {isNewEnvironmentAdd && (
                  <div className='contentCard'>
                    {(envIcon || envName) && (
                      <div className='enviromentCardItems'>
                        <div className='enviromentCardItems'>
                          <div className='newIcon'>
                            {envIcon && <img src={`${envIcon}`} alt='Icon' />}
                          </div>
                          <div className='enviromentItemsDetails'>
                            <span>
                              {envName.length ? envName : "New Environment"}
                            </span>
                            <span>0 Devices</span>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className='informationCard'>
                      <h1 className='stepperCardHeading'>
                        Contact Information
                      </h1>
                      <div className='cardInputs'>
                        <div className='inputCardItem finput'>
                          <Typography>Environment Name</Typography>
                          <span className='environmentNameInput'>
                            <InputField
                              placeholder='Type an answer'
                              type='text'
                              onChange={e => setEnvName(e.target.value)}
                              value={envName}
                            />
                          </span>
                        </div>
                        <div className='inputCardItem sinput'>
                          <Typography>Location</Typography>
                          {sameAddress ? (
                            <InputField value={environmentAddress} disabled />
                          ) : (
                            <span className='xyz'>
                              {/* <label className="envAutoLocLable">
                              Location
                            </label> */}
                              <Autocomplete
                                id='popupEnvLocInput'
                                className='autocomplete'
                                apiKey={
                                  "AIzaSyDJ3I1GNJkB4YhqogpYWDWcEh4vR1yc9P8"
                                }
                                options={{
                                  types: ["address"],
                                }}
                                onPlaceSelected={place => {
                                  setEnvironmentAddress(
                                    place.formatted_address
                                  );
                                  setEnvLat(place.geometry.location.lat());
                                  setEnvLong(place.geometry.location.lng());
                                }}
                                onChange={e =>
                                  setEnvironmentAddress(e.target.value)
                                }
                                value={environmentAddress}
                              />
                            </span>
                          )}
                          {/* <span className="sameAddressCheckbox">
                          <CustomCheckbox
                            checkedId={"envSameAddress"}
                            pressCheck={(e) => onSameAddressPress(e)}
                            checkValue={sameAddress}
                          />
                          Same as Main Address
                        </span> */}
                        </div>
                      </div>
                    </div>
                    <div className='icons'>
                      <div>
                        <p className='iconHeading'>Icon</p>
                        <div className='iconList'>
                          {envIcons?.length > 0 &&
                            envIcons?.map((icon, index) => (
                              <div
                                key={index}
                                className={`icon ${
                                  icon.icon === envIcon ? "selectedIcon" : ""
                                }`}
                                onClick={() => setEnvIcon(icon.icon)}>
                                <img src={`${icon.icon}`} alt='icon' />
                              </div>
                            ))}
                        </div>
                      </div>
                      <div>
                        <div className='actionbuttons'>
                          <Button onClick={() => setIsNewEnvironmentAdd(false)}>
                            <CancleIcon />
                          </Button>
                          <Button onClick={() => onSaveEnv()}>
                            <TickIcon />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </ValidatorForm>
          </div>
        ) : null}
        {(location?.pathname === "/business-customer" && activeStep === 2) ||
        (location?.pathname !== "/business-customer" && activeStep === 1) ? (
          <div className='stepperContendSecond'>
            <h1 className='secondStepHeading'>Choose Product</h1>
            <div>
              <Button
                color='primary'
                variant='contained'
                onClick={() => onSelectProductModal("selectProduct")}
                startIcon={<Add />}>
                {deviceOverviewInfo?.slectedDevice
                  ? "Change Product"
                  : "Product Selector"}
              </Button>
            </div>
            {deviceOverviewInfo?.slectedDevice ? (
              <div className='changeProduct'>
                <div className='changedProductItem'>
                  <Typography className='itemPropertie'>
                    Product Name
                  </Typography>
                  <Typography className='itemPropertieValue'>
                    {deviceOverviewInfo?.slectedDevice.productName}
                  </Typography>
                </div>
                <div className='changedProductItem itemBoader'>
                  <Typography className='itemPropertie'>SKU</Typography>
                  <Typography className='itemPropertieValue'>
                    {deviceOverviewInfo?.slectedDevice.sku}
                  </Typography>
                </div>
              </div>
            ) : null}
            <div className='stepperDeviceDetails'>
              {deviceOverviewInfo?.companyUser?.contactName && (
                <div className='changeProduct'>
                  <div className='changedProductItem'>
                    <Typography className='itemPropertie'>User Name</Typography>
                    <Typography className='itemPropertieValue'>
                      {deviceOverviewInfo?.companyUser?.contactName}
                    </Typography>
                  </div>
                  <div className='changedProductItem itemBoader'>
                    <Typography className='itemPropertie'>
                      Purchase Location
                    </Typography>
                    <Typography className='itemPropertieValue'>
                      {deviceOverviewInfo?.companyLocation?.address}
                    </Typography>
                  </div>
                </div>
              )}
              <ValidatorForm>
                <h1 className='secondStepHeading'>Device Details</h1>
                <div className='cardInputs'>
                  <div className='inputCardItem'>
                    <p>Device Name</p>

                    <InputField
                      disabled={
                        deviceOverviewInfo?.slectedDevice ? false : true
                      }
                      type='text'
                      placeholder='Type an answer'
                      onChange={e =>
                        dispatch(
                          endUserActions.onChangeOfRegister(
                            "deviceName",
                            e.target.value
                          )
                        )
                      }
                      value={deviceOverviewInfo?.deviceName}
                    />
                  </div>
                  <div className='inputCardItem'>
                    <p>Serial Number</p>
                    <InputField
                      disabled={
                        deviceOverviewInfo?.slectedDevice ? false : true
                      }
                      type='text'
                      placeholder='Type an answer'
                      onChange={e => {
                        setSerialNo(e.target.value);
                        dispatch(
                          endUserActions.onChangeOfRegister(
                            "serialNumber",
                            e.target.value
                          )
                        );
                      }}
                      value={deviceOverviewInfo?.serialNumber}
                      onBlur={() => onCheckDuplicate()}
                    />
                    {deviceOverviewInfo?.serialNumber === "" ? (
                      <span style={{ color: "red" }}>
                        {"Please enter serial number"}
                      </span>
                    ) : null}
                    {isDuplicate && deviceOverviewInfo?.serialNumber !== "" ? (
                      <span style={{ color: "red" }}>
                        {"Serial number is duplicated"}
                      </span>
                    ) : null}
                    {serLengthError ? (
                      <span style={{ color: "red" }}>
                        {"Name characters cannot exceed from 50."}
                      </span>
                    ) : null}
                  </div>
                </div>
                {/*<div className='cardInputs'>
                   <div className='inputCardItem'>
                    <p>Device Price</p>

                    <InputField
                      disabled={
                        deviceOverviewInfo?.slectedDevice ? false : true
                      }
                      type='text'
                      placeholder='Type an answer'
                      onChange={e => {
                        const inputValue = e.target.value.trim();
                        if (inputValue === "" || isNaN(inputValue) || parseFloat(inputValue) < 0) {
                          dispatch(endUserActions.onChangeOfRegister("devicePrice", ""));
                        } else {
                          dispatch(endUserActions.onChangeOfRegister("devicePrice", parseFloat(inputValue)));
                        }
                      }}
                      value={deviceOverviewInfo?.devicePrice}
                    />
                    {deviceOverviewInfo?.devicePrice === "" ? (
                      <span style={{ color: "red" }}>
                        {"Please enter a valid positive number"}
                      </span>
                    ) : null}
                  </div> 
                  <div className='inputCardItem'>
                    <p>Device Model</p>
                    <InputField
                      disabled={
                        deviceOverviewInfo?.slectedDevice ? false : true
                      }
                      type='text'
                      placeholder='Type an answer'
                      onChange={e =>
                        dispatch(
                          endUserActions.onChangeOfRegister(
                            "deviceModel",
                            e.target.value
                          )
                        )
                      }
                      value={deviceOverviewInfo?.deviceModel}
                    />
                    {deviceOverviewInfo?.deviceModel === "" ? (
                      <span style={{ color: "red" }}>
                        {"Please enter serial number"}
                      </span>
                    ) : null}
                    {serLengthError ? (
                      <span style={{ color: "red" }}>
                        {"Name characters cannot exceed from 50."}
                      </span>
                    ) : null}
                  </div> 
                </div>*/}
                <div className='cardInputs'>
                  <div className='inputCardItem'>
                    <p>Purchase Date</p>
                    <InputField
                      type='date'
                      disabled={!deviceOverviewInfo?.slectedDevice}
                      placeholder='Type an answer'
                      inputProps={{
                        max: maxPurchaseDate,
                      }}
                      id='purchase-date'
                      name='purchase-date'
                      onChange={e => {
                        dispatch(
                          endUserActions.onChangeOfRegister(
                            "purchaseDate",
                            e.target.value
                          )
                        );
                      }}
                      value={deviceOverviewInfo?.purchaseDate}
                    />
                  </div>
                  <div className='inputCardItem'>
                    <p>Installation Date</p>
                    <InputField
                      disabled={
                        !deviceOverviewInfo?.slectedDevice ||
                        !deviceOverviewInfo?.purchaseDate
                      }
                      id='Installation-date'
                      name='Installation-date'
                      type='date'
                      inputProps={{
                        ...insallationDateLimits,
                      }}
                      placeholder='Type an answer'
                      onChange={e => {
                        dispatch(
                          endUserActions.onChangeOfRegister(
                            "installationDate",
                            e.target.value
                          )
                        );
                      }}
                      value={deviceOverviewInfo?.installationDate}
                    />
                  </div>
                </div>
                <div className='cardInputs'>
                  {!deviceOverviewInfo?.companyUser?.contactName && (
                    <div className='inputCardItem'>
                      <p>Purchase Location</p>
                      <span>
                        <AutoComplete
                          isDisable={
                            deviceOverviewInfo?.slectedDevice ? false : true
                          }
                          value={deviceOverviewInfo?.purchaseLocation}
                          onChange={e => {
                            debouncedChangeHandler(e, deviceOverviewInfo);
                            dispatch(
                              endUserActions.onChangeOfRegister(
                                "purchaseLocation",
                                e.target.value
                              )
                            );
                            dispatch(
                              endUserActions.onChangeOfRegister(
                                "purchaseLocId",
                                ""
                              )
                            );
                          }}
                          eventLocation={allDelears}
                          setEvent={v => {
                            dispatch(
                              endUserActions.onChangeOfRegister(
                                "purchaseLocation",
                                v.value
                              )
                            );
                            dispatch(
                              endUserActions.onChangeOfRegister(
                                "purchaseLocId",
                                v.id
                              )
                            );
                            dispatch(
                              endUserActions.onChangeOfRegister(
                                "comLocId",
                                v.companyId
                              )
                            );
                          }}
                        />
                      </span>
                    </div>
                  )}
                  <div className='inputCardItem cardItemUploading'>
                    <Button
                      variant='contained'
                      color='primary'
                      className='uploadRecieptBtn'
                      onClick={() => recieptModal("uploadReciept")}>
                      Upload Receipt
                    </Button>
                    {recipt.name && (
                      <div className='reciptPdf'>
                        <span className='fileLink'>{recipt.name}</span>
                        <span>
                          <IconButton
                            className={"deleteIcon"}
                            onClick={handleDeleteFile}>
                            <Delete />
                          </IconButton>
                        </span>
                      </div>
                    )}
                    <RecieptModal
                      recieptModal={recieptModal}
                      open={open}
                      isUploadRecieptModal={isUploadRecieptModal}
                      isDispatch={true}
                      setRecipt={setRecipt}
                    />
                    <SelectProductModal
                      onCloseProductModal={onSelectProductModal}
                      open={openModal}
                      deviceOverviewInfo={deviceOverviewInfo}
                      setOpenModal={setOpenModal}
                    />
                  </div>
                </div>
              </ValidatorForm>
            </div>
          </div>
        ) : null}
        {(location?.pathname === "/business-customer" && activeStep === 3) ||
        (location?.pathname !== "/business-customer" && activeStep === 2) ? (
          <div className='stepperContent'>
            <NewProductDetail
              deviceOverviewInfo={{
                ...deviceOverviewInfo,
                image: deviceOverviewInfo?.slectedDevice?.productMainImage,
              }}
            />
          </div>
        ) : null}
        <div className='stepperNextButton'>
          <Button
            variant='contained'
            color='primary'
            style={{ marginTop: "15px" }}
            disabled={!isStepValid(activeStep)}
            onClick={handleNext}>
            {activeStep === steps.length - 1 ? "Finish" : "Next"}
          </Button>
        </div>
      </div>
    </div>
  );
};
